import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import ContactUs from "./pages/Contact";
import Work from "./pages/Work";
import CctvCamera from "./pages/Our Services/CctvCamera";
import VideoPhone from "./pages/Our Services/VideoPhone";
import Boom from "./pages/Our Services/Boom";
import Epabx from "./pages/Our Services/Epabx";
import Access from "./pages/Our Services/Access";
import Networking from "./pages/Our Services/Networking";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/cctv-camera" element={<CctvCamera />} />
          <Route path="/video-door-phone" element={<VideoPhone />} />
          <Route path="/boom-barrier-system" element={<Boom />} />
          <Route path="/epabx" element={<Epabx />} />
          <Route path="/networking-solutions" element={<Networking />} />
          <Route path="/access-control" element={<Access />} />
          <Route path="/our-work" element={<Work />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
